import { createContext } from 'react';
import { UploadingFile } from '~/hooks/dataset/useDatasetFileUploader';

interface DatasetUploadingContextValues {
  uploadingSupportiveDocs: Map<string, UploadingFile>;
  uploadingDataFiles: Map<string, UploadingFile>;
}

const DatasetUploadingContext = createContext<DatasetUploadingContextValues | null>(null);
export default DatasetUploadingContext;
